// ✅ Final version of Edituser.js with country code + number, file preview, and fixed profile image loading

import React, { useState, useEffect } from "react";
import { Row, Col, Form, Card, Button } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Avatar from "../../../assets/img/default.jpg";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { getInterests, editUser, fileUpload, getUserDetails } from "../../../common/api";
import ConfigApp from "../../../common/config";
import { ShowToast } from "../../../common/function";
import { Sentry, Spinner } from "react-activity";


const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function Edituser() {
  const navigate = useNavigate();
  const { userId } = useLocation().state;
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [phone, setPhone] = useState("");
  const [locationText, setLocationText] = useState("");
  const [coordinates, setCoordinates] = useState(null);
  const [gender, setGender] = useState("");
  const [ageGroup, setAgeGroup] = useState("");
  const [interests, setInterests] = useState([]);
  const [allInterests, setAllInterests] = useState([]);
  const [imageUri, setImageUri] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [userName, setUserName] = useState("");
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    getInterests(token).then((res) => {
      if (res.success) {
        setAllInterests(res.body);
      }
    });
  }, []);

  useEffect(() => {
    setLoading(true);
    const token = localStorage.getItem("token");
    const payload = { userId };
    getUserDetails(token, payload).then((res) => {
      setLoading(false);
      if (res?.success && res.body) {
        const data = res.body;
        setName(data.full_name || "");
        setEmail(data.email || "");
        setPhone(data.phone_number || "");
        setStatus(data.is_active === "0" ? "0" : "1");
        setGender(data.gender || "");
        setLocationText(data.location || "");
        setCoordinates({ lat: parseFloat(data.latitude), lng: parseFloat(data.longitude) });
        setImageUri(data.profile_url || null);
        setAgeGroup(
          data.ageGroup?.min === 18 && data.ageGroup?.max === 24 ? "18-24" :
          data.ageGroup?.min === 25 && data.ageGroup?.max === 34 ? "25-34" :
          data.ageGroup?.min === 35 && data.ageGroup?.max === 44 ? "35-44" :
          data.ageGroup?.min === 45 && data.ageGroup?.max === 54 ? "45-54" :
          data.ageGroup?.min >= 55 ? "55+" : ""
        );
        setInterests(data.interests || []);
        setUserName(data.user_name || "");
      }
    });
  }, [userId]);

  const handleImageChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setSelectedFile(file);
    const token = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("images[]", file);
    try {
      const response = await fileUpload(token, formData);
      if (response?.success && response.body?.[0]) {
        setImageUri(response.body[0]);
      }
    } catch (err) {
      console.error("Image upload error:", err);
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!name.trim()) errors.name = "Name is required.";
    if (!email.trim()) {
      errors.email = "Email is required.";
    } else if (!emailRegex.test(email)) {
      errors.email = "Invalid email format.";
    }
    if (!phone.trim()) errors.phone = "Phone number is required.";
    if (!status) errors.status = "Status is required.";
    if (!locationText.trim()) errors.location = "Location is required.";
    if (!gender) errors.gender = "Gender is required.";
    if (!ageGroup) errors.ageGroup = "Age group is required.";
    if (interests.length === 0) errors.interests = "Select at least one interest.";
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForm();
    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;
    const token = localStorage.getItem("token");

    const [min, max] = ageGroup.split("-");
    setIsLoading(true)
    const payload = {
      userId: userId, // from useLocation().state
      full_name: name,
      user_name: userName,
      email,
      is_active: status,
      phone_number: phone,
      profile_url: imageUri || null,
      latitude: coordinates?.lat,
      longitude: coordinates?.lng,
      addressLatLong: {
        type: "Point",
        coordinates: [coordinates?.lng, coordinates?.lat],
      },
      location: locationText,
      gender,
      ageGroup: { min: parseInt(min), max: parseInt(max) },
      interests,
      addpreference: false, // or true if needed
    };
    console.log(payload);
    editUser(token, payload).then((res) => {
      setIsLoading(false)
      if (res?.success) {
        ShowToast(1, "User updated successfully");

        navigate("/users");
      } else {
        ShowToast(0, res.message || "User update failed");
      }
    });
  };

  return (
    <Card>
      <Card.Header className="d-flex align-items-center justify-content-between flex-wrap">
        <h5>Edit User</h5>
        <Link className="btn btn-primary2 px-4 min_width140" to="/users">Back</Link>
      </Card.Header>
      <Card.Body>
        {loading ? (
          <Sentry
            color="#2B5AAC"
            size={30}
            speed={1}
            animating={true}
            style={{ marginLeft: "45%", marginTop: "110px" }}
          />
        ) : (
          <>
              <Form onSubmit={handleSubmit}>
          <Row className="mt-3">
            <Col md={5} xl={4} className="text-center">
              <img
                src={
                  selectedFile
                    ? URL.createObjectURL(selectedFile)
                    : imageUri
                    ? imageUri.startsWith("http")
                      ? imageUri
                      : `${ConfigApp.IMAGE_URL}${imageUri}`
                    : Avatar
                }
                className="rounded-circle img-fluid"
                alt="profile"
                style={{ width: 120, height: 120, objectFit: "cover" }}
              />
              <div className="mt-3">
                <label htmlFor="uploadprofileimg" style={{ cursor: "pointer" }}>
                  <div
                    style={{
                      display: "inline-block",
                      padding: "10px 24px",
                      borderRadius: "8px",
                      border: "2px solid #1d4ed8",
                      color: "#1d4ed8",
                      fontWeight: "600",
                      transition: "0.3s",
                    }}
                  >
                    Choose Picture
                  </div>
                </label>
                <input
                  type="file"
                  id="uploadprofileimg"
                  className="d-none"
                  accept="image/*"
                  onChange={handleImageChange}
                />
              </div>
            </Col>

            <Col md={7} xl={8}>
              <Row>
                <Col lg={6} className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    value={name}
                    placeholder="Enter Name"
                    onChange={(e) => setName(e.target.value)}
                    isInvalid={!!formErrors.name}
                  />
                  <Form.Control.Feedback type="invalid">{formErrors.name}</Form.Control.Feedback>
                </Col>

                <Col lg={6} className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    placeholder="Enter Email"
                    onChange={(e) => setEmail(e.target.value)}
                    isInvalid={!!formErrors.email}
                  />
                  <Form.Control.Feedback type="invalid">{formErrors.email}</Form.Control.Feedback>
                </Col>

                <Col lg={6} className="mb-3">
                  <Form.Label>UserName</Form.Label>
                  <Form.Control
                    type="text"
                    value={userName}
                    placeholder="Enter UserName"
                    onChange={(e) => setUserName(e.target.value)}
                    isInvalid={!!formErrors.userName}
                  />
                  <Form.Control.Feedback type="invalid">{formErrors.userName}</Form.Control.Feedback>
                </Col>

                <Col lg={6} className="mb-3">
                  <Form.Label>Phone</Form.Label>
                  <div className={`form-control p-0 ${formErrors.phone ? "is-invalid" : ""}`} style={{ height: "auto" }}>
                    <PhoneInput
                      country={"in"}
                      value={phone}
                      onChange={(value) => setPhone(value)}
                      inputStyle={{ border: "none", width: "100%" }}
                      buttonStyle={{ border: "none", background: "transparent" }}
                      placeholder="Enter phone number"
                    />
                  </div>
                  {formErrors.phone && <div className="invalid-feedback d-block">{formErrors.phone}</div>}
                </Col>

                <Col lg={6} className="mb-3">
                  <Form.Label>Status</Form.Label>
                  <Form.Select value={status} onChange={(e) => setStatus(e.target.value)} isInvalid={!!formErrors.status}>
                    <option value="">Select Status</option>
                    <option value="0">Active</option>
                    <option value="1">Inactive</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">{formErrors.status}</Form.Control.Feedback>
                </Col>

                <Col lg={6} className="mb-3">
                  <Form.Label>Gender</Form.Label>
                  <Form.Select value={gender} onChange={(e) => setGender(e.target.value)} isInvalid={!!formErrors.gender}>
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Others">Others</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">{formErrors.gender}</Form.Control.Feedback>
                </Col>

                <Col lg={6} className="mb-3">
                  <Form.Label>Age Group</Form.Label>
                  <Form.Select value={ageGroup} onChange={(e) => setAgeGroup(e.target.value)} isInvalid={!!formErrors.ageGroup}>
                    <option value="">Select Age Group</option>
                    <option value="18-24">18–24</option>
                    <option value="25-34">25–34</option>
                    <option value="35-44">35–44</option>
                    <option value="45-54">45–54</option>
                    <option value="55+">55+</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">{formErrors.ageGroup}</Form.Control.Feedback>
                </Col>

                <Col lg={12} className="mb-3">
                  <Form.Label>Interests</Form.Label>
                  <div className="d-flex flex-wrap gap-2">
                    {allInterests.map((interest, i) => (
                      <Button
                        key={i}
                        variant={interests.includes(interest) ? "primary" : "outline-secondary"}
                        className="btn-sm"
                        onClick={() => {
                          setInterests((prev) =>
                            prev.includes(interest) ? prev.filter((item) => item !== interest) : [...prev, interest]
                          );
                        }}
                      >
                        {interest}
                      </Button>
                    ))}
                  </div>
                  {formErrors.interests && <div className="text-danger mt-2">{formErrors.interests}</div>}
                </Col>
              </Row>
              <Button className="btn btn-primary mt-3 px-4 min_width140" type="submit" disabled={isLoading}>
                {isLoading ? (
                  <Spinner animation="border" variant="primary" size={15} />
                ) : (
                  "Update"
                )}
              </Button>
            </Col>
          </Row>
        </Form>
          </>
        )}
      </Card.Body>
    </Card>
  );
}
